var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_427_4998",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_427_4998)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13.2341,
    y: -13.7229,
    width: 81.7417,
    height: 76.2922,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_427_4998",
    transform: "scale(0.0169492)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_427_4998",
    width: 59,
    height: 59,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA7CAYAAADFJfKzAAADmklEQVRoge2ZQXLaShCG/xbDnhuEnMC8ExjfwDlBrIVUxer5neDhE5isVDXjqnFOEHIC4xMEThB8gkfWkvnfwgolxIgAtidG0V/FRg10f+qRprsH8CxjTP/m5ubct18ACHw7JGmXy+W1tbbj27dXWGPMpYh0RaSbZdmlT98AIL4cWWs7WZZ9B7DKaJZl7weDwdxXDN4ym2XZCAVQAGi1Wte+/AOeMmuM6QO4qzCfRVE08RGHr8xebLF5e3a9wJI83WLeZntR+crsjwNtLyovsCIyrrKRrLS9tLzAKqVGJGfl6yRn7XZ76CMGwOM+CwDGmCHJPgCIyEQpNQrDcOEzhkZ1lLdlnBcWa9sMyYc4jm99xaB8OQLQB/Bv6do9AG+w3lu836k/CnanZ1ZrfRoEQZdk9xm++vlnJZJzETl4GZNcAJjGcXy/y/crYY0xfZJ/i0gfpdbsLYrkWEQ+beugNmCttZ00Ta9FZFun8pY1UUp9cBUra7Ba6x4AKyI9b6G9gkjOAXyI43havL6CdY1NjlwLkmdF4BWs1vrbLzL6kN+xNyMR6QJ4V2UnOW2322c/l7QCAK31xRbQrySH5SXxVqS17onIJYCPZZuI9PIp5hDIM2uM+Q+O5Usy9FnOPUd5wqzDtFBKvQ/DcBHk03nXc3p1LKAAkMf6j8PUSdP0HAACkq6jiIcoirw11S+lKIpGAB7K10VkBbtRFfkclbyCNlYjyRMACERkY7oXBIGXOe4raSP2/K3tbgTymrN2CioGYQcV/FrrnjHmWUca1tqO1toeesonIq5d5QfwlNnNGvKp+N9L+X53B+BSa+3aAn6pvC6/E5GLNE3vDgFeLpeu2KfAE6yrWPiYJMnO2S2AdgBARC72BS6A9vL/6O0LbK3tiIiruJgDQPD4+Dhy/VAptVOwZdCCg52By6CF/9gLOE3T63IcAEByBOQVlNZ64norkxy32+2warZbBVrSJMuysOocNkmSbqvV+rKtLic5BRBWlazb2lKSsziOn1ZLIehvFb4WAG5JjuM4vk+SpKuUOiF5vmfPO8pv3gwA0jQ9yTf7nU/xSN6KyDjLstlgMJhrrU8B9ERkiIobTvKvnzdp1fUYY4bYnP4du66KleBa826MuYWjezhSfY6iaG3lrRUVudFVTB+brsqgQMXAreqFdQwieR/HsbNO+KPmxg1sXdXA1lUNbF3VwNZVDWxd1cDWVQ1sXdXANqqB/gdMk59CQtjidAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.4a3a3f783aad6a1b9355e90101c40a85.svg";
export { ForwardRef as ReactComponent };